import { render } from "./HomeAbout.vue?vue&type=template&id=29b46de1&scoped=true&ts=true"
import script from "./HomeAbout.vue?vue&type=script&lang=ts"
export * from "./HomeAbout.vue?vue&type=script&lang=ts"

import "./HomeAbout.vue?vue&type=style&index=0&id=29b46de1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b46de1"]])

export default __exports__